var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPencilNoCirclecomponent = function SvgPencilNoCirclecomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.533 4.223a.747.747 0 0 1 0 1.057L14.16 6.652 11.347 3.84l1.373-1.373a.747.747 0 0 1 1.057 0l1.756 1.756ZM2.25 15.75v-2.813l8.295-8.294 2.813 2.812-8.296 8.295H2.25Z",
    fill: "#A08264"
  })));
};
export default SvgPencilNoCirclecomponent;